import { createStore } from "vuex";
import Cookies from "js-cookie";

export default createStore({
  state: {
    schoolId: "", // 登录时请求用
    showDialog: false,
    dialogData: [],
    tokenValue: {},

    //-----------------------
    screenshotState: false, // 巡课截图状态
    screenshot: {}, // 巡课详情截图
    screenshotTime: "", // 巡课详情截图 视频当前播放时间（暂时废弃）
    //-----------------------

    //-----------------------
    // 播放器控件数据
    videoCurrentTime: 0, // 当前视频播放时间
    videoCurrentTotaTime: 0, // 当前视频总时长
    videoConTrolData: {
      playbackNum: 0, // 回放使用（多段视频播放默认第一个 可手动选择视频列表控制播放段落）
      LeadVideoNum: 0, // 主角播放器是否播放完成 完成更改此状态 （监听此状态播放下一段视频并执行过滤出视频时长最大的）
      // 自定义控制条数据 ( 禁止覆盖此对象 覆盖后 将监听不到对象内部字段变化)
      isPaused: false, // false暂停 true播放
      rate: 1.0, // 当前倍速
      liveUrlType: "m3u8HighStream", // 清晰度 // m3u8HighStream高清 // m3u8SuperStream超清
      volume: 0, // 音量
      mutedState: true, // 静音
      isBig: false, // false小屏  true 大屏 *暂时弃用 已用自定义方法实现 具体方法到-->（src\views\Frontpage\TeachingActivities\components\controlStrip）*
      currentTime: "", // 当前播放时长 原数据（秒）
      currentTimeDispose: "0:00", // 当前播放时长
      TotalTime: "", // 总时长 原数据（秒）
      TotalTimeDispose: "0:00", //总时长 转移后00:00:00 用于展示
    },

    VideoCurrentOpenTime: "", // 点击或 拖动进度条时间 / 打点跳转时间  (接收秒数)
    loadWaiting: "", // 视频是否缓冲了状态(用来控制多个播放器为暂停/加载状态)使所有播放器播放时间一致
    mutedStateS: [true, true, true, true], // 单独实例小屏控制静音（默认三个分屏 三个以上可像数组内扩展）
    timerShaftList: [],
    seniorCount: 0, //  严重预警
    intermediateCount: 0, //  中度预警
    commonlyCount: 0, // 一般预警
    defaultWordsList: [], //词云
    behaviorlist: [], // 视频行为集合
    aiTeacherBehavior: {}, // 教师行为
    emoVo: {}, // 各个表情峰值数据
    poseVo: {}, // 各个行为峰值数据
    toClass: "",//　　到课率
    headUp: "",//　　抬头率
    headDownRate: "",//　低头率
    frontRow: "",//　　前排率
    totalExpected: "", // 应到人数
    totalAttended: "", // 出席人数
    frontRowExpected: "", // 前排应到人数
    frontRowActual: "", // 前排实际人数
    allPeopleSize: "",//　学生数
    leaveSize: "",//  迟到人数
    ImgSrc: "",
    showCurrentTime: "",// 全局监听 基础设置 状态变化
    videoSource: [],// 视频来源 录播机录制 摄像机录制视频
  },
  getters: {
    getSchoolId: (state) => state.schoolId,

    //-----------------------
    // 巡课截图状态
    getScreenshotState: (state) => state.screenshotState,
    // 巡课详情截图
    getScreenshot: (state) => state.screenshot,
    // 视频当前截图播放时间
    getScreenshotTime: (state) => state.screenshotTime,
    //-----------------------

    //播放器控件数据
    //-----------------------
    getVideoCurrentTime: (state) => state.videoCurrentTime,
    getVideoCurrentTotaTime: (state) => state.videoCurrentTotaTime,
    getvideoConTrolData: (state) => state.videoConTrolData,
    getTimerShaftList: (state) => state.timerShaftList,
    getVideoCurrentOpenTime: (state) => state.VideoCurrentOpenTime,
    getloadWaiting: (state) => state.loadWaiting,
    getmutedStateS: (state) => state.mutedStateS,
    getEarlyWarning: (state) => state.earlyWarning,
    getDefaultWordsList: (state) => state.defaultWordsList,
    getBehaviorlist: (state) => state.behaviorlist,
    getAITeacherBehavior: (state) => state.aiTeacherBehavior,
    getImgSrc: (state) => state.ImgSrc,
    getTotalExpected: (state) => state.totalExpected,
    getTotalAttended: (state) => state.totalAttended,
    getFrontRowExpected: (state) => state.frontRowExpected,
    getFrontRowActual: (state) => state.frontRowActual,
    //-----------------------

    getShowCurrentTime: (state) => state.showCurrentTime,
    getvideoSource: (state) => state.videoSource,
  },
  mutations: {
    setSchoolId(state, row) {
      state.schoolId = row;
      Cookies.set("schoolId", row);
    },
    setDialogVisibility(state, isVisible) {
      state.showDialog = isVisible;
    },
    setDialogData(state, data) {
      state.dialogData = data;
    },
    setTokenValue(state, data) {
      state.tokenValue = data;
    },

    //-----------------------
    // 巡课截图状态
    updateScreenshotState(state, data) {
      state.screenshotState = data;
    },
    // 巡课详情截图
    updateScreenshot(state, data) {
      state.screenshot = data;
    },
    // 视频当前截图播放时间
    updateScreenshotTime(state, data) {
      state.screenshotTime = data;
    },
    //-----------------------

    //-----------------------
    //播放器控件数据
    // 当前视频播放时间
    updateVideoCurrentTime(state, currentTime) {
      state.videoCurrentTime = currentTime;
    },
    // 当前视频总时长
    updateVideoCurrentTimeTotalTime(state, TotalTime) {
      state.videoCurrentTotaTime = TotalTime;
    },
    // 操作进度条进度条
    updateVideoCurrentOpenTime(state, data) {
      state.VideoCurrentOpenTime = data;
    },
    // 修改播放器实例为缓冲状态
    updateLoadWaiting(state, data) {
      state.loadWaiting = data;
    },
    // 播放器实例
    updateMutedStateS(state, data) {
      state.mutedStateS = data;
    },
    updateTimerShaftList(state, data) {
      if (data) {
        state.timerShaftList.unshift(data);
      } else {
        state.timerShaftList = [];
      }
    },
    INCREMENT_COMMONLY_COUNT(state, payload) {
      state.commonlyCount++;
    },
    INCREMENT_INTERMEDIATE_COUNT(state, payload) {
      state.intermediateCount++;
    },
    INCREMENT_SENIOR_COUNT(state, payload) {
      state.seniorCount++;
    },
    updateDefaultWordsList(state, data) {
      state.defaultWordsList = data;
    },
    // 视频行为集合
    updateBehaviorlist(state, item) {
      state.behaviorlist = item;
    },
    // 教师行为
    updateAITeacherBehavior(state, item) {
      state.aiTeacherBehavior = item;
    },
    // 更新各个表情峰值数据
    updateEmoVo(state, data) {
      state.emoVo = data;
    },
    // 更新各个行为峰值数据
    updatePoseVo(state, data) {
      state.poseVo = data;
    },
    INCREMENT_TOCLASS(state, payload) {
      state.toClass = payload; // 这里根据需要更新状态
    },
    INCREMENT_HEAD_UP(state, payload) {
      state.headUp = payload; // 这里根据需要更新状态
    },
    INCREMENT_HEAD_DOWN_RATE(state, payload) {
      state.headDownRate = payload; // 这里根据需要更新状态
    },
    INCREMENT_FRONT_ROW(state, payload) {
      state.frontRow = payload; // 这里根据需要更新状态
    },
    INCREMENT_ALL_PEOPLE_SIZE(state, payload) {
      state.allPeopleSize = payload; // 这里根据需要更新状态
    },
    updateImgSrc(state, data) {
      state.ImgSrc = data;
    },
    updateTotalExpected(state, data) {
      state.totalExpected = data;
    },
    updateTotalAttended(state, data) {
      state.totalAttended = data;
    },
    updateFrontRowExpected(state, data) {
      state.frontRowExpected = data;
    },
    updateFrontRowActual(state, data) {
      state.frontRowActual = data;
    },
    updateLeaveSize(state, data) {
      state.leaveSize = data;
    },


    //-----------------------

    updateShowCurrentTime(state, data) {
      state.showCurrentTime = data;
    },
    updateVideoSource(state, data) {
      state.videoSource = data;
    }
  },
  actions: {
    setSchoolId({ commit }, row) {
      commit("setSchoolId", row);
      Cookies.set("schoolId", row);
    },
    setDialogVisibility({ commit }, isVisible) {
      commit("setDialogVisibility", isVisible);
    },
    setDialogData({ commit }, data) {
      commit("setDialogData", data);
    },
    setTokenValue({ commit }, data) {
      commit("setTokenValue", data);
    },
    //-----------------------
    // 巡课截图状态
    setScreenshotState({ commit }, value) {
      commit("updateScreenshotState", value);
    },
    // 巡课详情截图
    setScreenshot({ commit }, value) {
      commit("updateScreenshot", value);
    },
    // 视频当前截图播放时间
    setScreenshotTime({ commit }, value) {
      commit("updateScreenshotTime", value);
    },
    //-----------------------

    //-----------------------
    //播放器控件数据
    setVideoCurrentTime({ commit }, currentTime) {
      commit("updateVideoCurrentTime", currentTime);
    },
    setVideoCurrentTotalTime({ commit }, TotalTime) {
      commit("updateVideoCurrentTimeTotalTime", TotalTime);
    },
    setVideoCurrentOpenTime({ commit }, data) {
      commit("updateVideoCurrentOpenTime", data);
    },
    setLoadWaiting({ commit }, data) {
      commit("updateLoadWaiting", data);
    },
    setMutedStateS({ commit }, data) {
      commit("updateMutedStateS", data);
    },
    setTimerShaftList({ commit }, data) {
      commit("updateTimerShaftList", data);
    },
    incrementCommonlyCount({ commit }, payload) {
      commit("INCREMENT_COMMONLY_COUNT", payload);
    },
    incrementIntermediateCount({ commit }, payload) {
      commit("INCREMENT_INTERMEDIATE_COUNT", payload);
    },
    incrementSeniorCount({ commit }, payload) {
      commit("INCREMENT_SENIOR_COUNT", payload);
    },
    setDefaultWordsList({ commit }, data) {
      commit("updateDefaultWordsList", data);
    },
    setBehaviorlist({ commit }, item) {
      commit("updateBehaviorlist", item);
    },
    setAITeacherBehavior({ commit }, item) {
      commit("updateAITeacherBehavior", item);
    },
    setEmoData({ commit }, data) {
      commit("updateEmoVo", data);
    },
    setPoseData({ commit }, data) {
      commit("updatePoseVo", data);
    },
    incrementToClassCount({ commit }, payload) {
      commit("INCREMENT_TOCLASS", payload);
    },
    incrementHeadUpCount({ commit }, payload) {
      commit("INCREMENT_HEAD_UP", payload);
    },
    incrementHeadDownRate({ commit }, payload) {
      commit("INCREMENT_HEAD_DOWN_RATE", payload);
    },
    incrementFrontRowCount({ commit }, payload) {
      commit("INCREMENT_FRONT_ROW", payload);
    },
    incrementAllPeopleSizeCount({ commit }, payload) {
      commit("INCREMENT_ALL_PEOPLE_SIZE", payload);
    },
    setImgSrc({ commit }, data) {
      commit("updateImgSrc", data);
    },
    setTotalExpected({ commit }, data) {
      commit("updateTotalExpected", data);
    },
    setTotalAttended({ commit }, data) {
      commit("updateTotalAttended", data);
    },
    setFrontRowExpected({ commit }, data) {
      commit("updateFrontRowExpected", data);
    },
    setFrontRowActual({ commit }, data) {
      commit("updateFrontRowActual", data);
    },
    setLeaveSize({ commit }, data) {
      commit("updateLeaveSize", data);
    },
    //-----------------------
    setShowCurrentTime({ commit }, data) {
      commit("updateShowCurrentTime", data)
    },
    // 视频来源
    setVideoSource({ commit }, data) {
      commit("updateVideoSource", data);
    }
  },
  modules: {},
});
